import React, { useState, useEffect, useMemo, useCallback } from 'react';
import Select from 'react-select';
import TextareaAutosize from 'react-textarea-autosize';

function AgentsFilter({ filters, setFilters, updateShowTrends, allAgentInfo }) {
  const [callIdInput, setCallIdInput] = useState(filters.callId || '');
  const [showTrends, setShowTrends] = useState(false);

  const dateOptions = useMemo(
    () => [
      { value: 'today', label: 'Today' },
      { value: 'thisWeek', label: 'This Week' },
      { value: 'thisMonth', label: 'This Month' },
      { value: 'thisYear', label: 'This Year' },
      { value: 'all', label: 'All' },
      { value: 'custom', label: 'Custom' },
    ],
    []
  );

  const handleChange = useCallback(
    (selectedOptions, { name }) => {
      setFilters((prev = {
        category: [],
        intent: [],
        agent: null,
        excludeWeekends: true,
        callId: '',
        dateRange: { value: 'today', label: 'Today' },
      }) => {
        const newFilters = {
          ...prev,
          [name]: selectedOptions
        };
        
        return newFilters;
      });
    },
    [setFilters]
  );

  useEffect(() => {
    const handler = setTimeout(() => {
      setFilters((prev = {
        category: [],
        intent: [],
        agent: null,
        callId: '',
        dateRange: { value: 'today', label: 'Today' },
      }) => {
        if (prev.callId === callIdInput) {
          return prev; // No change, avoid re-render
        }
        return { ...prev, callId: callIdInput };
      });
    }, 300);
  
    return () => {
      clearTimeout(handler);
    };
  }, [callIdInput, setFilters]);
  
  const customStyles = {
    control: (provided) => ({
      ...provided,
      minHeight: '38px',
      height: 'auto',
    }),
    option: (provided) => ({
      ...provided,
      display: 'flex',
      justifyContent: 'space-between',
    }),
    multiValue: (provided) => ({
      ...provided,
      backgroundColor: '#e2e8f0',
    }),
    multiValueLabel: (provided) => ({
      ...provided,
      fontSize: '14px',
    }),
    valueContainer: (provided) => ({
      ...provided,
      flexWrap: 'nowrap',
      overflowX: 'auto',
      maxHeight: '100px',
    }),
    menu: (provided) => ({
      ...provided,
      zIndex: 1000, // Increase this value as needed
    }),
  };
  const formattedAgentInfo = useMemo(() => {
    return allAgentInfo.map(agent => ({
      value: agent.agent,  // Assuming 'agent' is the identifier
      label: agent.agent,  // You can modify this if you want to display a different label
      count: agent.totalCalls
    }));
  }, [allAgentInfo]);
  
  const formatAgentLabel = ({ label, count }, { context }) => {
    if (context === 'menu') {
      return (
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <span>{label}</span>
          <span style={{ color: '#aaa', paddingLeft: '5px' }}>({count})</span>
        </div>
      );
    } else {
      return label;
    }
  };

  const handleExcludeWeekends = (event) => {
    console.log("Handle exclude weekends", event.target.checked);
    setFilters((prev) => ({ ...prev, excludeWeekends: event.target.checked }));
  };

  const handleShowTrends = () => {
    setShowTrends(!showTrends);
    updateShowTrends(!showTrends);
  };

  return (
    <div className="mb-4 p-4 bg-gray-100 rounded-lg">
      <div className="flex space-x-8 mb-1 ml-5 mr-5">
        <div className="flex-1 relative">
          <Select
            name="agent"
            value={filters.agent}
            onChange={(option) => handleChange(option, { name: 'agent' })}
            options={formattedAgentInfo}
            isClearable
            placeholder="Select Agent"
            styles={customStyles}
            formatOptionLabel={formatAgentLabel}
            theme={(theme) => ({
              ...theme,
              colors: {
                ...theme.colors,
                primary: 'rgb(129 140 248)',
              },
            })}
          />
        </div>
        <div className="flex-1 relative">
          <Select
            name="dateRange"
            value={filters.dateRange}
            onChange={(option) => handleChange(option, { name: 'dateRange' })}
            options={dateOptions}
            styles={customStyles}
            theme={(theme) => ({
              ...theme,
              colors: {
                ...theme.colors,
                primary: 'rgb(129 140 248)',
              },
            })}

          />
        </div>
        <div className="relative">
          <label className="flex items-center space-x-2 mt-2">
            <input
              type="checkbox"
              checked={filters.excludeWeekends}
              onChange={handleExcludeWeekends}
              className="form-checkbox h-5 w-5 text-indigo-600 accent-indigo-600"
            />
            <span className="text-sm">Exclude weekends</span>
          </label>
        </div>
        <div className="hidden relative">
          <button
            onClick={handleShowTrends}
            className="px-4 py-1 bg-indigo-800 text-white rounded hover:bg-indigo-600 text-sm mt-1"
          >
            {showTrends ? "Hide Trends" : "Show Trends"}
          </button>
        </div>
      </div>
    </div>
  );
}

export default AgentsFilter;
